import { http } from "@/api/client";
import type { ApiItemResponse, ApiListResponse } from "@/api/types";
import type { Package } from "@/types/domain";

export interface CreatePackageBody {
  id?: string;
  game_id: string;
  name?: string;
  region?: string;
  region_name?: string;
  platform?: string;
  bundle_id?: string;
  app_id?: string;
  store_url?: string;
  config_status?: string;
}

export const packagesApi = {
  list: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<Package>>("/api/packages", query),
  get: (id: string) => http.get<ApiItemResponse<Package>>(`/api/packages/${id}`),
  create: (body: CreatePackageBody) => http.post<ApiItemResponse<Package>>("/api/packages", body),
  update: (id: string, body: Partial<Package>) => http.patch<ApiItemResponse<Package>>(`/api/packages/${id}`, body),
  remove: (id: string) => http.delete<ApiItemResponse<Package>>(`/api/packages/${id}`),
  configHistory: (id: string) => http.get<ApiListResponse<unknown>>(`/api/packages/${id}/config-history`),
};
